import Reactn,{useEffect,useState} from 'react';
import {Link,useHistory} from "react-router-dom";
import {auth, data} from './firebase';
import "./css/Header.css";
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useStateValue } from './StateProvider';
import MenuIcon from '@material-ui/icons/Menu';
var c=0;
var m=1;

function Header() {
    const history =useHistory();
    const[{user},dispatch]=useStateValue();
    const [userHead,setHeadData]=useState([]);
    useEffect(()=>{
        auth.onAuthStateChanged(authUser=>{
            if(authUser){
                dispatch({
                    type:'SET_USER',
                    user: authUser
                })
                
            }else{
                dispatch({
                    type:'SET_USER',
                    user: null
                })
            }
        })
        
    },[])
    function Menu(){
        if(m%2==0){
            var menu = document.getElementById("menu")
            menu.style.display="none"
            m++;
        }else{
            var menu = document.getElementById("menu")
            menu.style.display="block"
            m++;
        }
    }
    function X() {
        console.log("klk")
        if(!user){
            var log=document.getElementById('login');  
            var app=document.getElementById('app');  
            app.style.pointerEvents="none";
            log.style.pointerEvents="all";
            log.style.display="block";
        }else{
            
            if(c%2==0){
                var elementbox=document.getElementById('elementboxs'); 
                elementbox.style.display="block"
                c++;
            }else{
                var elementbox=document.getElementById('elementboxs'); 
                elementbox.style.display="none"
                c++;
            }
        }
    }
    function D() {
        history.push("/")
        auth.signOut()
    }
    if(user){
        data.collection("Users").doc(user.uid).onSnapshot(y=>(
            setHeadData(y.data())
        ))
        return   <nav className="header">
        <div className="maxw">
            <Link to="/">
                <img className="logo" src="https://www.avito.ma/img/logo-rbnd.png"/>
            </Link>


            <div className="menu" id="menu">
                <Link to="/Search/sea=&city=3&catégories=0" className="re">
                    <p className="">Rechercher</p>
                </Link>
                <Link to="/Chat" className="re">
                    <p className="">Chat</p>
                </Link>
                <a className="dd" onClick={X}>
                
                <div className="dd" id="elementbox" >
                    <a href="/account?tab=Mes_annonces" className="ff">
                        <ListAltIcon className="icon"/>
                        <p>Mes annonces</p> 
                    </a>
                    <a href="/account?tab=Mes_favoris" className="ff">
                        <FavoriteBorderOutlinedIcon className="icon"/>
                        <p>Mes favoris</p>
                    </a>
                    <a href="/account?tab=Chat" className="ff">
                        <QuestionAnswerOutlinedIcon className="icon"/>
                        <p>Chat</p>
                    </a>
                    <a href="/account?tab=Réglages" className="ff">
                        <SettingsOutlinedIcon className="icon"/>
                        <p>Réglages</p>
                    </a>
                    <a onClick={D} className="ff">
                        <ExitToAppIcon className="icon"/>
                        <p>Déconnexion</p>
                    </a>
                </div>
                </a>
                <Link to="/Deposer" className="b">
                    <p className="deposer"><CameraAltOutlinedIcon className="ico"/>Déposer une annonce</p>
                </Link>
            </div>

            
            <div className="links">
                <Link to="/Search/sea=&city=3&catégories=0" className="b">
                    <p className="link">Rechercher</p>
                </Link>
                <Link to="/Chat" className="b">
                    <p className="link">Chat</p>
                </Link>
                <a className="b bo" onClick={X}>
                <p className="link">{userHead.Prénom}</p>
                <div className="elementbox" id="elementboxs">
                    <a href="/account?tab=Mes_annonces" className="a">
                        <ListAltIcon className="icon"/>
                        <p>Mes annonces</p> 
                    </a>
                    <a href="/account?tab=Mes_favoris" className="a">
                        <FavoriteBorderOutlinedIcon className="icon"/>
                        <p>Mes favoris</p>
                    </a>
                    <a href="/account?tab=Chat" className="a">
                        <QuestionAnswerOutlinedIcon className="icon"/>
                        <p>Chat</p>
                    </a>
                    <a href="/account?tab=Réglages" className="a">
                        <SettingsOutlinedIcon className="icon"/>
                        <p>Réglages</p>
                    </a>
                    <a onClick={D} className="a">
                        <ExitToAppIcon className="icon"/>
                        <p>Déconnexion</p>
                    </a>
                    
                    
                </div>
                </a>
                <Link to="/Deposer" className="b">
                    <p className="link a"><CameraAltOutlinedIcon className="ico"/>Déposer une annonce</p>
                </Link>
                <MenuIcon onClick={Menu} className="Hamburger"/>
            </div>
        </div>
    </nav>
    }else{
        return   <nav className="header">
        <div className="maxw">
            <Link to="/">
                <img className="logo" src="https://www.avito.ma/img/logo-rbnd.png"/>
            </Link>

            <div className="menu" id="menu">
                <Link to="/Search/sea=&city=3&catégories=0" className="re">
                    <p className="">Rechercher</p>
                </Link>
                <Link to="/Chat" className="re">
                    <p className="">Chat</p>
                </Link>
                <a className="" onClick={X}>
                <p className="">{userHead.Prénom}</p>
                <a className="secon" onClick={X}>
                    <p className="">Se connecter</p>
                </a>
                </a>
                <Link to="/Deposer" className="b">
                    <p className="link a"><CameraAltOutlinedIcon className="ico"/>Déposer une annonce</p>
                </Link>
            </div>


            <div className="links">
                <Link to="/Search/sea=&city=3&catégories=0" className="b">
                    <p className="link">Rechercher</p>
                </Link>
                <Link to="/Chat" className="b">
                    <p className="link">Chat</p>
                </Link>
                
                <a className="b" onClick={X}>
                    <p className="link">Se connecter</p>
                </a>
                <Link to="/Deposer" className="b">
                    
                    <p className="link a"><CameraAltOutlinedIcon className="ico"/>Déposer une annonce</p>
                </Link>
            </div>
            <MenuIcon className="Hamburger" onClick={Menu}/>
        </div>
    </nav>
    }
}

export default Header